import { Suspense, useState } from "react";
import { breadcrumbInformeDicom } from "../utils/BreadcrumbItem";
import { Box, Paper } from "@mui/material";
import { FiltrosComponent, TablaComponent } from "../components";
import { FormFIltersInformeDicom } from "../interfaces/FormFiltersInformeDicom";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";

interface Props {};

const InformeDICOM: React.FC<Props> = ({}: Props) => {
    
    const [formFilters, setFormFilters] = useState<FormFIltersInformeDicom & { trigger: number }>({
        trigger: 0,
        fecha: null,
    });

    const handleFilters = (formFilters: FormFIltersInformeDicom) =>
        setFormFilters(prev => ({ ...formFilters, trigger: prev.trigger + 1 }));

    return (
        <Suspense>
            <Breadcrumb items={ breadcrumbInformeDicom } />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <Suspense>

                        <FiltrosComponent handleFilters={handleFilters} />

                        { formFilters.fecha != null && 
                            <TablaComponent
                                key={formFilters.trigger}
                                formFilters={formFilters}
                            /> 
                        }

                    </Suspense>
                </Paper>
            </Box>
        </Suspense>
    );
}

export default InformeDICOM;